'use strict';

var helper = require("./helper")
var lcache = require("./lcache")
var net = require("./net")
var config = require("./config")

var xseed = {
	version:"0.01",
	/**
	 * 这个函数是给待缓存的js文件调用的，由于跨域原因，不能用ajax获取js文件，只能让目标js文件调用方法来存储自己
	 * 使用方法如下
	 * xseed.cacheAndExecute(function(){
	 * 		xxxxxx目标文件代码
	 * })
	 * @param  {[type]} func [description]
	 * @return {[type]}      [description]
	 */
	store:function(key,func){
		var funcString = func.toString()
		var ret = lcache.save(config.pre+key,funcString)
		this.execCode(funcString)
		console.log(ret)
	},
	launch:function(){
		//找到自己的script标签
		var scripts = document.getElementsByTagName("script")
		var len = scripts.length
		var that = this
		for(var i=0;i<len;++i){
			var script = scripts[i]
			if(script.src && script.src.toLowerCase().indexOf("\/xseed.js")>=0){
				var url = script.dataset.source.toLowerCase()
				var runUrl = script.dataset.run
				var key = config.pre+helper.getUrlKey(url)
				var content = lcache.load(key)
				if(content){
					this.execCode(content,function(){
						console.log("inject cache script complete")
						that.loadRunScript(runUrl)
					})	
				}else{
					net.loadResource(url,function(){
						console.log("source loadcompleted: "+url)
						setTimeout(function(){
							that.loadRunScript(runUrl)
						},10)
					})
				}
				break
			}
		}
	},

	//加载目标运行script
	loadRunScript:function(url){
		net.loadResource(url)
	},
	// 执行代码片段
	execCode:function(codeStr, callback) {
		var script = document.createElement('script');
		script.defer = false;
		// Have to use .text, since we support IE8,
		// which won't allow appending to a script
		script.text = '('+codeStr+')()';
		var head = document.head || document.getElementsByTagName('head')[0];
		head.appendChild( script );
		setTimeout(function(){
			callback&&callback()
		},0)
	}
}
window.xseed = xseed
xseed.launch()

// lcache.saveResource("//gbfek.dfcfw.com/project/gubawap/bundle/zepto_react_all_xseed.js")


//////////////////
// WEBPACK FOOTER
// ./src/xseed.js
// module id = 2
// module chunks = 0